module.exports = __webpack_public_path__ + "2ff2ced4ed7bb558af8c5e6976b5235f.png";